// 메일 템플릿 목록의 조건값(ID)을 이름으로 보여 주기 위한 순수 헬퍼.
// node:test + webpack 양쪽 사용을 위해 CommonJS 로 작성.
const conditionTokens = require('./conditionTokens')

// 이름 조회가 필요한 엔티티만. project(코드)·brand(서브도메인)는 값 자체가 이미 읽을 수 있는 이름이라 조회하지 않는다.
const NAME_ENTITIES = ['campaign', 'company', 'user']

// GET /mail/lookup/<entity>?ids= 는 호출당 200 토큰까지 받는다.
const LOOKUP_CHUNK_SIZE = 200

// 캐시 키 — '535' 가 캠페인과 기업 양쪽에 있을 수 있어 엔티티를 앞에 붙인다.
function labelKey(entity, token) {
    return `${entity}:${token}`
}

// 화면에 있는 행들의 조건 토큰을 엔티티별로 모은다(행 간 중복 제거, 캐시에 있는 건 제외, 200개씩 분할).
// entityOf: contexts 키 → 엔티티. cache: labelKey → { label, sub } | null(찾을 수 없음).
function collectLookupRequests(rows, entityOf, cache) {
    const byEntity = new Map()
    const known = cache || {}
    ;(rows || []).forEach((row) => {
        if (!row || row.is_fallback) return
        const contexts = row.contexts || {}
        Object.keys(contexts).forEach((key) => {
            const entity = entityOf(key)
            if (NAME_ENTITIES.indexOf(entity) === -1) return
            conditionTokens.splitTokens(contexts[key]).forEach((token) => {
                if (conditionTokens.isRangeToken(token)) return
                // ids= 를 쉼표로 이어 보내므로 쉼표가 든 토큰은 어차피 매칭되지 않는다(200개 상한만 부풀림).
                if (token.indexOf(',') !== -1) return
                if (labelKey(entity, token) in known) return
                if (!byEntity.has(entity)) byEntity.set(entity, new Set())
                byEntity.get(entity).add(token)
            })
        })
    })
    const requests = []
    byEntity.forEach((tokens, entity) => {
        const ids = [...tokens]
        for (let i = 0; i < ids.length; i += LOOKUP_CHUNK_SIZE) {
            requests.push({ entity, ids: ids.slice(i, i + LOOKUP_CHUNK_SIZE) })
        }
    })
    return requests
}

// 값 토큰 하나당 표시 조각. 이름을 찾았으면 { text: 이름, id: 원래 값 }, 못 찾았으면 { text: 원문, id: null }.
function conditionValueParts(entity, value, cache) {
    const known = cache || {}
    return conditionTokens.splitTokens(value).map((token) => {
        const found = NAME_ENTITIES.indexOf(entity) === -1 ? null : known[labelKey(entity, token)]
        if (!found || !found.label) return { text: token, id: null }
        return { text: found.label, id: token }
    })
}

// 한 줄 텍스트가 필요한 곳(시뮬레이션 배지 등)용. ID 는 넣지 않는다 — 배지 title 에 원문이 있다.
// 이름을 하나도 못 찾으면 저장된 원문을 구분자까지 그대로 둔다.
function conditionValueText(entity, value, cache) {
    const parts = conditionValueParts(entity, value, cache)
    if (!parts.some(p => p.id)) return parts.map(p => p.text).join('|')
    return parts.map(p => p.text).join(', ')
}

module.exports = {
    NAME_ENTITIES,
    LOOKUP_CHUNK_SIZE,
    labelKey,
    collectLookupRequests,
    conditionValueParts,
    conditionValueText,
}
